module.exports = __webpack_public_path__ + "media/yipingfang.3acb7112.mp3";